<template>
    <div class="paginator md-layout md-alignment-center-right">
                        <div class="md-alignment-item md-layout md-alignment-center-right">
                            <!-- <span>Items per page:</span>
                            <md-field>
                                <md-select v-model="step">
                                    <md-option value="5">5</md-option>
                                    <md-option value="10">10</md-option>
                                    <md-option value="15">15</md-option>
                                </md-select>
                            </md-field> -->
                            <span>{{start + 1}}-{{end + 1}} of {{length}}</span>
                            <md-button @click="stepBack" :disabled="disableBackward" class="md-icon-button">
                                <md-icon>
                                    keyboard_arrow_left
                                </md-icon>
                            </md-button>
                            <md-button @click="stepForward" :disabled="disableForward" class="md-icon-button">
                                <md-icon>
                                    keyboard_arrow_right
                                </md-icon>
                            </md-button>
                        </div>
                    </div>
</template>

<script>
export default {
    name: "Paginator",
    props:{
        list:{
            type: Array,
            default: () => []
        } 
    },
    data: function(){
       return {
            step: 5,
            start: 0
       } 

    },
    computed: {
        length: function(){
            return this.list.length
        },
        localList: function(){
            return this.list.slice(this.start, this.end + 1)
        },
        end: function(){
            return this.start + this.step  <= this.length ? this.start + this.step - 1 : this.length - 1
        },
        disableForward: function(){
            return this.end === this.length - 1;
        },
        disableBackward: function(){
            return this.start === 0;
        }
    },
    methods: {
        stepForward(){
            this.start = this.end + 1;
        },
        stepBack(){
            this.start = this.start - this.step;
        }
    },
    created(){
        this.$emit('paginated-list', this.localList)
    },
    watch:{
        length: function(){
            this.$emit('paginated-list',this.localList);
        },
        start: function(){
            this.$emit('paginated-list',this.localList);
        }
    }
}
</script>

<style lang="scss" scoped>
    .md-field{
        padding: 0 0.5em;
        width: 4em;
    }
</style>

